import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('../pages/RootPage'))
const TicketsListPage = lazy(() => import('../pages/TicketsListPage'))

export const ticketingRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.ticketing.path,
      element: <RootPage />,
      handle: {
        module: 'ai_ticketing',
      },
      children: [
        {
          index: true,
          element: <TicketsListPage />,
        },
      ],
    },
  ]
}
